import React from "react";
import Menu from "../Menu";
import PopUp from "../PopUp";
import Config from "../../services/api/Config.js";
import Confirm from "../Confirm";
import HamburgerMenu from "../../assets/css/images/hamburger_icon.png";
import { hasRole, roleInUse, permInUse } from "../../services/Common";
import { defaultSettings } from "../../services/Common.js";
import { addItem, save } from "../../services/store/reducers/cart/actions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "./footer.css";

class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...this.createMenu(defaultSettings),
            settings: defaultSettings,
            last_target: "",
            popup: false,
            menu: false,
            tabsIsOpen: false,
            active: props.location.pathname.substring(1)
        };
    }

    createMenu = (settings) => {
        let buttons = [];
        let enableLegacyRoleMenu = false;
        if (
            (roleInUse() && !hasRole("kitchenview_role")) ||
            (hasRole("kitchenview_role") && (hasRole("manager") || hasRole("manager_with_pin")))
        ) {
            enableLegacyRoleMenu = true;
        }
        if (!roleInUse() && !permInUse()) {
            enableLegacyRoleMenu = true;
        }
        if (!hasRole("courier_role")) {
            if (hasRole("perm_table") || enableLegacyRoleMenu) {
                buttons.push({
                    path: "tables",
                    text: "ASZTALOK"
                });
            }

            if (hasRole("perm_orders") || enableLegacyRoleMenu) {
                buttons.push({
                    path: "orders",
                    text: "RENDELÉS"
                });
            }

            if (hasRole("perm_phone") || enableLegacyRoleMenu) {
                buttons.push({
                    path: "phone-order",
                    text: "TELEFONOS"
                });
            }
        }

        if (
            hasRole("perm_courier") ||
            (roleInUse() && hasRole("courier_role")) ||
            enableLegacyRoleMenu
        ) {
            buttons.push({
                path: "courier",
                text: "FUTÁR"
            });
        }
        if (hasRole("perm_kitcenview") || enableLegacyRoleMenu || hasRole("kitchenview_role")) {
            buttons.push({
                path: "kitchen",
                text: "KONYHA"
            });
        }

        if (
            (enableLegacyRoleMenu &&
                !hasRole("courier_role") &&
                settings !== null &&
                settings.menu_billing == 1) ||
            hasRole("perm_invoices")
        ) {
            buttons.push({
                path: "invoices",
                text: "SZÁMLÁK"
            });
        }

        let count = Math.floor(12 / buttons.length);
        let isInteger = Number.isInteger(12 / buttons.length);

        return {
            buttons,
            count,
            isInteger
        };
    };
    clickSettings = (e) => {
        this.props.history.push("/settings");
    };
    componentDidMount() {
        this.getSettings();
        this.setState(this.createMenu(this.state.settings));
        if (this.props.location.state && this.props.location.state.page) {
            this.setState({ active: this.props.location.state.page });
        }
        window.addEventListener("keydown", this.listenMenu);
    }
    initSettings = (fiteredSettings) => {
        let settings = (fiteredSettings[0] && fiteredSettings[0]["value"]) || null;

        this.setState(
            {
                settings: JSON.parse(settings) || defaultSettings
            },
            () => {
                this.setState(this.createMenu(JSON.parse(settings) || defaultSettings));
            }
        );
    };
    getSettings = () => {
        if (
            typeof this.props.config === "undefined" ||
            Object.keys(this.props.config).length == 0
        ) {
            Config.getConfigs().then((result) => {
                let fiteredSettings = result.filter((i) => i.key == "epossettings");
                this.initSettings(fiteredSettings);
            });
        } else {
            this.initSettings(this.props.config);
        }
    };
    componentWillUnmount() {
        window.removeEventListener("keydown", this.listenMenu);
    }

    listenMenu = (e) => {
        switch (e.keyCode) {
            case 112: //f1
                if (!hasRole("courier_role") && hasRole("perm_table")) {
                    e.preventDefault();
                    this.redirect("tables");
                }
                break;
            case 113: //f2
                if (!hasRole("courier_role") && hasRole("perm_orders")) {
                    e.preventDefault();
                    this.redirect("orders");
                }
                break;
            case 114: //f3
                if (!hasRole("courier_role") && hasRole("perm_phone")) {
                    e.preventDefault();
                    this.redirect("phone-order");
                }
                break;
            case 115: //f4
                if (!hasRole("courier_role") && hasRole("perm_courier")) {
                    e.preventDefault();
                    this.redirect("courier");
                }
                break;
            case 116: //f5
                if (!hasRole("courier_role") && hasRole("perm_invoices")) {
                    e.preventDefault();
                    return this.redirect("invoices");
                }
                if (hasRole("perm_kitcenview") || hasRole("kitchenview_role")) {
                    e.preventDefault();
                    return this.redirect("kitchen");
                }
            default:
                break;
        }
    };
    redirect = (page) => {
        this.props.history.push("/" + page + "", {
            page
        });
        this.setState({ active: page });
    };
    skipBack = () => {
        let path = window.location.hash;
        let b = path.includes("/table/") || path.includes("/category/") || path.includes("product");
        // let table_id = this.props.match.params.table_id;

        return b && this.props.is_saved === false;
    };
    disagreeHandler = (e) => {
        this.setState({ popup: false });
    };
    agreeHandler = () => {
        this.props.addToBasket({ cart_items: [] });
        this.props.save(true);
        this.setState(
            {
                popup: false
            },
            () => {
                this.redirect(this.state.last_target);
            }
        );
    };
    clickButton = (lastClickedTarget) => {
        let last_target = lastClickedTarget;

        if (this.skipBack()) {
            this.setState({
                popup: true,
                last_target,
                tabsIsOpen: false
            });
            return;
        }

        this.setState({ tabsIsOpen: false });
        this.redirect(lastClickedTarget);
    };
    renderButtons = (button, index) => {
        let style = "footer-button";
        if (button.path === "phone-order") style += " footer-phone-order-button";
        if (this.state.active === button.path) style += " active";
        if ((this.state.active === "" || this.state.active === "/") && button.path === "orders") {
            style += " active";
        }

        return (
            <div key={button.path} className={style} onClick={() => this.clickButton(button.path)}>
                {button.text}
            </div>
        );
    };
    shouldComponentUpdate(nextProps, nextState) {
        if (
            nextState.active != this.state.active ||
            nextState.menu != this.state.menu ||
            nextState.buttons != this.state.buttons ||
            nextState.popup != this.state.popup ||
            nextState.sticky != this.state.sticky ||
            nextState.tabsIsOpen != this.state.tabsIsOpen
        ) {
            return true;
        }

        return false;
    }
    openMenu = (e) => {
        this.setState((prevState) => {
            return { menu: !prevState.menu };
        });
    };

    toggleTabs = () => {
        this.setState({ tabsIsOpen: !this.state.tabsIsOpen });
    };
    componentWillReceiveProps = (nextProps) => {
        let { pathname } = nextProps.location;
        let sticky = "sticky";

        if (
            !pathname.startsWith("/tables") &&
            pathname.startsWith("/table") &&
            !pathname.includes("/product")
        ) {
            sticky = "sticky_65";
        }

        if (this.state.sticky !== sticky) {
            this.setState({
                sticky
            });
        }
    };
    render() {
        let { pathname } = this.props.location;
        if (pathname.startsWith("/printing")) return null;

        let classes = ["pos-footer", "use-full-width"];
        if (
            !pathname.startsWith("/tables") &&
            pathname.startsWith("/table") &&
            !pathname.includes("/product")
        ) {
            classes.push("use-65-width");
        }

        const isMobile = window.matchMedia("(max-width: 767px)");

        return (
            <footer className={classes.join(" ")}>
                {this.state.menu && <Menu close={() => this.setState({ menu: false })} />}
                <div className="footer-icon-container" onClick={this.openMenu}>
                    <img src={HamburgerMenu} className="footer-icon" />
                </div>
                <div className="footer-nav-mid-section">
                    <div
                        className={
                            this.state.tabsIsOpen ? "footer-buttons --open" : "footer-buttons"
                        }
                    >
                        {this.state.buttons
                            .sort((button1) => {
                                if (!isMobile.matches) return 0;
                                return this.state.active === button1.path ? 1 : -1;
                            })
                            .map(this.renderButtons)}
                    </div>
                    <div
                        className="tabs-toggler-in-footer-nav flaticon-menu"
                        onClick={(e) => {
                            this.toggleTabs();
                        }}
                    ></div>
                </div>

                <div className="footer-icon-container" onClick={() => window.location.reload()}>
                    <img src="images/reload.png" className="footer-icon reload-icon" />
                </div>
                {this.state.popup && (
                    <PopUp onClose={this.disagreeHandler} containerClass="popup_small">
                        <Confirm
                            agreeHandler={this.agreeHandler}
                            disagreeHandler={this.disagreeHandler}
                            question={"Biztosan kilépsz mentés nélkül?"}
                        />
                    </PopUp>
                )}
            </footer>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        is_saved: state.cart.is_saved,
        config: state.config
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        addToBasket: (item) => {
            dispatch(addItem(item));
        },
        save: (item) => {
            dispatch(save(item));
        }
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Footer));



// WEBPACK FOOTER //
// ./src/components/Footer/index.js